/* eslint-disable @typescript-eslint/no-explicit-any */
/* A single-flight request to native that resolves when window.jwt_inject is called */
type JwtResponse = { access_token: string; refresh_token?: string }

let inFlight: Promise<JwtResponse> | null = null
let resolver:
  | { resolve: (v: JwtResponse) => void; reject: (e?: any) => void; timer: any }
  | null = null

const ensureGlobalHandler = () => {
  const w = window as any

  w.jwt_inject ??= (payload: any) => {
    try {
      const data = typeof payload === 'string' ? JSON.parse(payload) : payload
      if (!resolver) return
      clearTimeout(resolver.timer)
      if (data && data.error) {
        resolver.reject(new Error(data.error))
      } else if (data && data.access_token) {
        resolver.resolve({
          access_token: data.access_token,
          refresh_token: data.refresh_token,
        })
      } else {
        resolver.reject(new Error('Invalid payload received from native app'))
      }
    } catch (e) {
      resolver?.reject(new Error('Failed to parse payload from native'))
    } finally {
      // Clear the inFlight promise on the next tick of the event loop.
      // This allows other code that awaits the promise to complete first.
      setTimeout(() => {
        inFlight = null
      }, 0)
      resolver = null
    }
  }
}

export const requestJwtFromNative = (
  currentAccessToken: string | null = null,
  timeoutMs = 15000
): Promise<JwtResponse> => {
  ensureGlobalHandler()
  if (inFlight) return inFlight

  inFlight = new Promise<JwtResponse>((resolve, reject) => {
    const w = window as any
    const timer = setTimeout(() => {
      inFlight = null
      resolver = null
      reject(new Error('JWT request to native app timed out'))
    }, timeoutMs)

    resolver = { resolve, reject, timer }

    try {
      if (w.webkit?.messageHandlers?.dashboardAppHandler) {
        w.webkit.messageHandlers.dashboardAppHandler.postMessage({
          event: 'jwt_request',
          data: currentAccessToken ? { access_token: currentAccessToken } : {},
        })
      } else if (w.AndroidInterface?.postMessage) {
        w.AndroidInterface.postMessage(
          JSON.stringify({
            event: 'jwt_request',
            data: currentAccessToken ? { access_token: currentAccessToken } : {},
          })
        )
      } else {
        reject(new Error('Not running inside a mobile WebView'))
      }
    } catch (e) {
      reject(e)
    }
  })

  return inFlight
}